import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { QuestionareService } from '../questionare.service';
import { AddQuestionareComponent } from '../add-questionare/add-questionare.component';
import { Questionare } from '../objects/Questionare';

@Component({
  selector: 'app-questionare-list',
  templateUrl: './questionare-list.component.html',
  styleUrls: ['./questionare-list.component.css']
})
export class QuestionareListComponent implements OnInit {
  questionares: Questionare[] = [];
  filteredQuestionares: Questionare[] = [];
  loading = true;
  error = '';
  searchTerm = '';
  confirmDeleteId: number | null = null;
  deleting = false;

  displayedColumns: string[] = ['questionareCategory', 'subCategory', 'questionareName', 'questionareDescription', 'actions'];

  constructor(private questionareService: QuestionareService, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = '';
    this.questionareService.getQuestionares().subscribe({
      next: (data) => { this.questionares = data; this.applyFilter(); this.loading = false; },
      error: () => { this.error = 'Failed to load questionnaires.'; this.loading = false; }
    });
  }

  applyFilter(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredQuestionares = term
      ? this.questionares.filter(q =>
          (q.questionareName || '').toLowerCase().includes(term) ||
          (q.questionareCategory || '').toLowerCase().includes(term) ||
          (q.subCategory || '').toLowerCase().includes(term))
      : [...this.questionares];
  }

  openAdd(): void {
    this.openDialog(undefined);
  }

  openEdit(q: Questionare): void {
    // Fetch the full questionnaire (with questions) before opening the dialog
    this.questionareService.getQuestionareById(q.id!).subscribe({
      next: (full) => this.openDialog(full),
      error: ()     => this.openDialog(q)   // fallback: open with what we have
    });
  }

  private openDialog(questionare?: Questionare): void {
    const ref = this.dialog.open(AddQuestionareComponent, {
      height: '90%',
      width: '95%',
      maxWidth: '600px',
      data: { questionare }
    });
    ref.afterClosed().subscribe(result => {
      if (result) this.load();
    });
  }

  requestDelete(id: number): void {
    this.confirmDeleteId = id;
  }

  cancelDelete(): void {
    this.confirmDeleteId = null;
  }

  confirmDelete(): void {
    if (this.confirmDeleteId === null) return;
    this.deleting = true;
    this.questionareService.deleteQuestionare(this.confirmDeleteId).subscribe({
      next: () => {
        this.questionares = this.questionares.filter(q => q.id !== this.confirmDeleteId);
        this.applyFilter();
        this.confirmDeleteId = null;
        this.deleting = false;
      },
      error: () => { this.error = 'Failed to delete questionnaire.'; this.confirmDeleteId = null; this.deleting = false; }
    });
  }
}
